"use client";

import { BadgeCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PostOnboardingMessageProps {
  handleClosePostOnboardMessage: () => void;
}

const MobilePostOnboardingMessage: React.FC<PostOnboardingMessageProps> = ({
  handleClosePostOnboardMessage,
}) => {
  return (
    <div className="max-w-sm mx-auto p-6 bg-white-1 text-center">
      <div className="flex flex-col items-center gap-2">
        <BadgeCheck className="h-10 w-10 text-green-500" />
        <h2 className="text-xl font-semibold text-green-600">
          Onboarding Successful
        </h2>
      </div>
      <p className="text-sm text-gray-600 mt-3 leading-relaxed">
        Thank you for completing the onboarding process. <br />
        Your account is currently under verification.
        Once verified, you’ll be able to log in and start placing orders seamlessly.
      </p>
      <Button onClick={handleClosePostOnboardMessage} className="mt-6 w-full">
        Got it
      </Button>
    </div>
  );
};

export default MobilePostOnboardingMessage;
